import {
  faBoltLightning,
  faBook,
  faHeadSideBrain,
  faUserGroup,
} from '@fortawesome/pro-solid-svg-icons'

import type { ProgramBenefit } from '@/client/services/programs/types'
import composeRichText from '@/client/services/richText/composeRichText'

export const LEARNER_BENEFITS: ProgramBenefit[] = [
  {
    id: 'virtual',
    text: composeRichText(ctx =>
      ctx.paragraph(
        ctx.text('Enroll in a virtual 4-week small-group tutoring course '),
        ctx.text('for the digital SAT', { bold: true }),
        ctx.text('.')
      )
    ),
    faIcon: faBook,
    iconProps: { color: 'purple.contrast', backgroundColor: 'purple.solid' },
  },
  {
    id: 'score-increase',
    text: composeRichText(ctx =>
      ctx.paragraph(
        ctx.text('Feel more prepared on test day. Research shows '),
        ctx.text('significant confidence gains', { bold: true }),
        ctx.text(' for participants.')
      )
    ),
    faIcon: faHeadSideBrain,
    iconProps: { color: 'purple.contrast', backgroundColor: 'purple.solid' },
  },
  {
    id: 'personalized-peer-tutor',
    text: composeRichText(ctx =>
      ctx.paragraph(
        ctx.text('Get personalized support from our '),
        ctx.text('certified, top-scoring peer tutors', { bold: true }),
        ctx.text('.')
      )
    ),
    faIcon: faUserGroup,
    iconProps: { color: 'purple.contrast', backgroundColor: 'purple.solid' },
  },
  {
    id: 'speedy',
    text: composeRichText(ctx =>
      ctx.paragraph(
        ctx.text('Get started in 5 minutes. '),
        ctx.text('100% free and non-profit', { bold: true }),
        ctx.text('.')
      )
    ),
    faIcon: faBoltLightning,
    iconProps: { color: 'purple.contrast', backgroundColor: 'purple.solid' },
  },
]
